import { Stack, styled } from "@mui/material";
import { ImgHTMLAttributes } from "react";
import closeIcon from '../../assets/close-icon.svg'

interface PreviewImageProps extends ImgHTMLAttributes<HTMLImageElement> {
    width?: string
    height?: string
    onDelete?: () => void
}

const StyledPreviewImage = styled('img')<PreviewImageProps>(({ width, height }) => ({
    width: width || '100%',
    height: height || '100%',
    borderRadius: '8px',
    objectFit: 'cover',
    border: '1px solid #ACACAC',
    cursor: 'pointer'
}))

export const PreviewImage = ({ width, height, onDelete, ...props }: PreviewImageProps) => {
    const handleImageClick = () => {
        if (props.src) {
            window.open(props.src, '_blank');
        }
    };

    return <Stack direction="row" gap="10px" position="relative">
        <StyledPreviewImage
            width={width}
            height={height}
            onClick={handleImageClick}
            {...props}
        />
        {onDelete && <div onClick={onDelete} style={{ cursor: 'pointer', position: 'absolute', top: '5px', right: '5px' }}>
            <img src={closeIcon} alt="close" />
        </div>}
    </Stack>
}